var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderDescendingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Table---Dropdown",
    transform: "translate(-28.000000, -150.000000)",
    fill: "#F0B423"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,160 L30,160 L30,166 L28,166 L28,160 Z M42,150 L44,150 L44,166 L42,166 L42,150 Z M35,155 L37,155 L37,166 L35,166 L35,155 Z",
    id: "Combined-Shape",
    transform: "translate(36.000000, 158.000000) scale(-1, 1) translate(-36.000000, -158.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderDescendingActive);
export default __webpack_public_path__ + "static/media/Icon_Order_Descending-Active.ae9cc6af3765351eb9c5876e5a8059b9.svg";
export { ForwardRef as ReactComponent };